module.exports = __webpack_public_path__ + "static/media/revert.8cf31c1a.svg";